import { createSvgIcon } from '@ori-ui/mui-bundle/material/utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20H13a.5.5 0 0 0 0-1H5.5a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5H13a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.384 8.68a.5.5 0 1 0-.768.64l1.817 2.18H11a.5.5 0 0 0 0 1h7.433l-1.817 2.18a.5.5 0 0 0 .768.64l2.5-3a.5.5 0 0 0 0-.64z"
  })]
}), 'Logout');
//# sourceMappingURL=index.js.map